import { SnowplowService } from 'wanderu-service-analytics';

const category = 'Interlinking';

function tabClicked() {
    SnowplowService.fireStructuredEvent({
        category,
        action: 'tab_clicked',
    });
}

export {
    tabClicked,
};

export default {
    tabClicked,
};
